module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("23CC7"))).then(() => module.bundle.root('cvs7o'));